import { Route, Routes, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import Homepage from "./Pages/Homepage";
import Contact from "./Pages/Contact";
import NotFound from "./Pages/NotFound";

const slideVariants = {
  initial: direction => ({
    x: direction > 0 ? 1000 : -1000,
    opacity: 0
  }),
  in: {
    x: 0,
    opacity: 1,
    transition: {
      type: "spring",
      stiffness: 100,
      damping: 12
    }
  },
  out: direction => ({
    x: direction > 0 ? -1000 : 1000,
    opacity: 0,
    transition: {
      duration: 0.5
    }
  })
};

function App() {
  const location = useLocation();
  const direction = location.pathname !== "/" ? 1 : -1;

  return (
    <AnimatePresence initial={false} custom={direction}>
      <Routes location={location} key={location.pathname}>
        <Route 
          path="/" 
          element={
            <motion.div
              custom={direction}
              variants={slideVariants}
              initial="initial"
              animate="in"
              exit="out"
            >
              <Homepage />
            </motion.div>
          }
        />
        <Route 
          path="/contact" 
          element={
            <motion.div
              custom={direction}
              variants={slideVariants}
              initial="initial"
              animate="in"
              exit="out"
            >
              <Contact />
            </motion.div>
          }
        />
        <Route 
          path="*" 
          element={
            <motion.div
              custom={direction}
              variants={slideVariants}
              initial="initial"
              animate="in"
              exit="out"
            >
              <NotFound />
            </motion.div>
          }
        />
      </Routes>
    </AnimatePresence>
  );
}

export default App;
